export const appDeleteIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path fill="currentColor" d="M6.857 18.222C6.857 19.2 7.63 20 8.571 20h6.858c.942 0 1.714-.8 1.714-1.778V7.556H6.857v10.666zM18 4.89h-3L14.143 4H9.857L9 4.889H6v1.778h12V4.889z"/></g></svg>`,
    name: 'delete' as const
};